import type { SemanticSIZES } from 'semantic-ui-react';
import { Loader } from 'semantic-ui-react';

import styles from './styles.module.scss';

interface LoadingContainerProps {
  isLoading?: boolean;
  size?: SemanticSIZES;
}

function LoadingPage({
  isLoading = false,
  size = 'medium',
}: LoadingContainerProps) {
  return (
    <div className={styles.loadingContainer}>
      {isLoading && (
        <div className={styles.absoluteLoader}>
          <Loader size={size} active aria-label="Carregando" />
        </div>
      )}
    </div>
  );
}

export { LoadingPage };
